module.exports = __webpack_public_path__ + "static/media/PCN-2024-8-20-01-LG11.9a61d24d.pdf";